import { jsx as r } from "react/jsx-runtime";
const t = ({
  size: H
}) => {
  switch (H) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M2.33502 11.7578V10.758H13.6684V11.7578H2.33502ZM2.33502 8.50145V7.50145H13.6684V8.50145H2.33502ZM2.33502 5.24495V4.24512H13.6684V5.24495H2.33502Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M3.5 17.634V16.1342H20.5V17.634H3.5ZM3.5 12.7495V11.2495H20.5V12.7495H3.5ZM3.5 7.86474V6.36499H20.5V7.86474H3.5Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M2.91833 14.6958V13.446H17.085V14.6958H2.91833ZM2.91833 10.6253V9.37535H17.085V10.6253H2.91833ZM2.91833 6.55472V5.30493H17.085V6.55472H2.91833Z",
          fill: "currentColor"
        }
      );
  }
}, e = ({
  size: H
}) => {
  switch (H) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M1.86499 12.1956V10.6789H14.136V12.1956H1.86499ZM1.86499 8.7586V7.24193H14.136V8.7586H1.86499ZM1.86499 5.3216V3.80493H14.136V5.3216H1.86499Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M2.79474 18.2911V16.0161H21.2012V18.2911H2.79474ZM2.79474 13.1356V10.8606H21.2012V13.1356H2.79474ZM2.79474 7.98008V5.70508H21.2012V7.98008H2.79474Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M2.33099 15.2432V13.3474H17.6697V15.2432H2.33099ZM2.33099 10.947V9.05113H17.6697V10.947H2.33099ZM2.33099 6.65072V4.75488H17.6697V6.65072H2.33099Z",
          fill: "currentColor"
        }
      );
  }
}, o = ({
  size: H = "md",
  weight: V = "default"
}) => {
  switch (V) {
    case "bold":
      return /* @__PURE__ */ r(e, { size: H });
    case "book":
    case "default":
      return /* @__PURE__ */ r(t, { size: H });
  }
};
export {
  o as default
};
//# sourceMappingURL=DIconHamburger.js.map
